// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OMf_","questions":"styles_questions__3ZeMK","footer":"styles_footer__1LAan"};